// mui-imports
import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project-imports
import CloseCheckbox from 'assets/images/icons/closeCheckbox.svg';
import SuccessCheckbox from 'assets/images/icons/successCheckbox.svg';
import { getFormattedDate } from 'helpers/dates';
import { capitalizeString } from 'helpers/stringFunctions';
import { useSelector } from 'store';
import SubCard from 'ui-component/cards/SubCard';
import useStyles from '../../styles';

const KycDetails = () => {
    const theme = useTheme();
    const classes = useStyles();

    const KYC_STATUS = {
        completed: { label: 'Completed', color: theme.palette.success.dark },
        pending: { label: 'Pending', color: theme.palette.grey.primary },
        submitted: { label: 'Submitted', color: theme.palette.warning.dark },
        rejected: { label: 'Rejected', color: theme.palette.orange.dark }
    };

    const memberDetailsData = useSelector((state) => state?.memberDetails);
    const { data = {} } = memberDetailsData;

    const { orgDetails = {} } = data || {};

    const {
        is_contract_signed: isContractSigned = false,
        kyc_status: kycStatus = '',
        registration_type: registrationType = '',
        no_gst_declaration: noGstDeclaration = false,
        no_gst_declaration_description: noGstDeclarationDescription = '',
        contract_signed_on: contractSignedOn = ''
    } = orgDetails || {};

    return (
        <>
            <Grid container item xs={12} spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h4" sx={{ fontWeight: 500 }}>
                        KYC Details
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <SubCard sx={{ boxShadow: 'none', '&:hover': { boxShadow: 'none' } }}>
                        <Grid container item spacing={0.5} rowSpacing={3}>
                            <Grid container item direction="column" xs={3} spacing={1}>
                                <Grid item>
                                    <Typography variant="subtitle1" className={classes.kycHeading}>
                                        KYC Status
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" sx={{ color: KYC_STATUS[kycStatus] || theme.palette.grey.primary }}>
                                        {KYC_STATUS[kycStatus]?.label || capitalizeString(kycStatus, ' ') || 'null'}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container item direction="column" xs={3} spacing={1}>
                                <Grid item>
                                    <Typography variant="subtitle1" className={classes.kycHeading}>
                                        Contract Signed
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <img src={isContractSigned ? SuccessCheckbox : CloseCheckbox} alt="checkbox" />
                                </Grid>
                            </Grid>
                            <Grid container item direction="column" xs={3} spacing={1}>
                                <Grid item>
                                    <Typography variant="subtitle1" className={classes.kycHeading}>
                                        Contract Signed on
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
                                        {getFormattedDate(contractSignedOn, 'dd-mm-yyyy', true) || '-'}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container item direction="column" xs={3} spacing={1}>
                                <Grid item>
                                    <Typography variant="subtitle1" className={classes.kycHeading}>
                                        Registration Type
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
                                        {capitalizeString(registrationType, ' ') || '-'}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container item direction="column" xs={3} spacing={1}>
                                <Grid item>
                                    <Typography variant="subtitle1" className={classes.kycHeading}>
                                        GST Declaration
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <img src={noGstDeclaration ? SuccessCheckbox : CloseCheckbox} alt="checkbox" />
                                </Grid>
                            </Grid>
                            <Grid container item direction="column" xs={9} spacing={1}>
                                <Grid item>
                                    <Typography variant="subtitle1" className={classes.kycHeading}>
                                        GST Declaration Description
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
                                        {noGstDeclarationDescription || '-'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </SubCard>
                </Grid>
            </Grid>
        </>
    );
};

export default KycDetails;
